import api from './../api';
import UserStore from '../../class/UserStore';
import {i18n} from '../../main';

export default {
    namespaced: true,
    state: {
        userStore: new UserStore(),
        user: {},
        serverKey: null,
    },
    getters: {
        userStore(state,getters) {
          return state.userStore;
        },
        account(state, getters) {
            return state.user;
        },
        hasPermission(state) {
            return function (slug, type) {
                if (state.user.userAcl === undefined) {
                    return false;
                }
                const found = state.user.userAcl.find(function (item) {
                    return item.acl.slug === slug;
                });
                return found !== undefined && found.value.includes(type);
            }
        },
      serverKey(state) {
          return state.serverKey
      },
    },
    actions: {
        login(store, params) {
            return new Promise((resolve, reject) => {
                api.post('account/login', params).then(response => {
                    if (response.data.error) {
                      reject(response)
                    } else {
                      let user = store.state.userStore.addOrPatch(response.data).logIn(response.data.status,Date.now());
                      resolve(response);
                    }
                }).catch(error => {
                    reject(error.response);
                });
            });
        },
        register(store, params) {
            return new Promise((resolve, reject) => {
                api.post('account/register', params).then(response => {
                    if(response.data.hasOwnProperty('valid') && response.data.valid === false) {
                        reject(response.data.status);
                        let text = i18n.t(response.data.status);
                        if(text.includes('{email}')) {
                          text = text.replace('{email}',response.data.email);
                        }
                        if(text.includes('{cellphone}')) {
                          text = text.replace('{cellphone}',response.data.cellphone);
                        }
                        store.dispatch('alert/error', text, {root: true});
                    }
                    else {
                        resolve(response.data);
                    }
                }).catch(error => {
                  reject(error.response);
                  store.dispatch('alert/error', error.response.data.status, {root: true});
                });

            });
        },
        refreshToken(store) {
          return new Promise((resolve, reject) => {
            api.get('account/refresh-token').then(response => {
              if (response.data.error) {
                reject(response)
              } else {
                store.state.userStore.getLoggedUser().refreshToken(response.data.status,Date.now());
                resolve();
              }
            }).catch(error => {
              reject(error.response);
            });
          });
        },
        activate(store, params) {
            return new Promise((resolve, reject) => {
                api.post('account/activate/' + params.userId + '/' + params.hash, {}).then(() => {
                    resolve();
                }).catch(error => {
                    reject(error.response);
                });
            });
        },
        get(store) {
            return new Promise((resolve, reject) => {
                api.getProfile().then(data => {
                    store.commit('setProfile', data);
                    store.commit('setServerKey', data.serverKey);
                    resolve(data);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        logout(store) {
            return new Promise((resolve, reject) => {
                api.post('account/logout').then(() => {
                    store.state.userStore.getLoggedUser().logOut();
                    store.commit('setProfile', {});
                    resolve();
                }).catch(error => {
                    reject(error.response);
                });
            });
        },
        changePassword(store, params) {
            return new Promise((resolve, reject) => {
                api.put('account/change-password', params).then(response => {
                    store.dispatch('alert/success', 'Password was changed', {root: true});
                    resolve(response);
                }).catch(error => {
                    reject(error.response);
                    store.dispatch('alert/error', error.response.data.status, {root: true});
                });
            });
        },
        updateProfile(store, params) {
            return new Promise((resolve, reject) => {
                api.put('account/update-profile', params).then(response => {
                    store.dispatch('alert/success', 'Profile was updated', {root: true});
                    resolve(response);
                }).catch(error => {
                    reject(error.response);
                    store.dispatch('alert/error', error.response.data.status, {root: true});
                });
            });
        },
        saveNotifications(store, params) {
            return new Promise((resolve, reject) => {
                api.put('account/update-notifications', params).then(response => {
                    store.dispatch('alert/success', 'E-mail notification was updated', {root: true});
                    resolve(response);
                }).catch(error => {
                    reject(error.response);
                    store.dispatch('alert/error', error.response.data.status, {root: true});
                });
            });
        },
        lostPassword(store, params) {
            return new Promise((resolve, reject) => {
                api.post('account/lost-password', params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error.response);
                });
            });
        },
        validateToken(store, params) {
            return api.get('account/get-lost-password/' + params.id + '/' + params.hash);
        },
        resetPassword(store, params) {
            return api.put('account/reset-password/' + params.id + '/' + params.hash, params);
        },
        loginAs(store, params) {
            //TODO: this is temporarily disabled
            return new Promise((resolve, reject) => {
                api.post('account/login-as/' + params.user, params).then(response => {
                    resolve(response.data);
                }).catch(error => {
                    reject(error.response);
                });
            });
        },
        verifyInfo(store, params) {
          return api.post('account/verify-info', params);
        },
        sendSecurityPin(store, params) {
          return new Promise((resolve, reject) => {
            api.post('account/send-security-pin', params).then(response => {
              if (response.data.error) {
                reject(response.data)
                return
              }

              resolve(response.data)
            }).catch(error => reject(error.response.data))
          })
        },
        confirmSecurityPin(store, params) {
          return api.post('account/confirm-security-pin', params);
        },
        storeKnownValue(store, params) {
          return api.put('account/store-known-value', params);
        },
        reset(store,params) {
          return api.post('account/reset', params);
        },
        acceptConditions(store, params) {
          return new Promise((resolve, reject) => {
            api.post('account/accept-conditions', params).then(response => {
              resolve(response.data);
            }).catch(error => {
              reject(error.response);
            });
          });
        },
        showConditionsPopup(store) {
          return new Promise((resolve, reject) => {
            api.post('account/show-conditions-popup').then(response => {
              resolve(response.data);
            }).catch(error => {
              reject(error.response);
            });
          });
        },
        initTwoFa(store) {
          return new Promise((resolve, reject) => {
            api.post('account/init-two-fa').then(response => {
              if (response.data.error) {
                reject(response.data)
                return
              }

              resolve(response.data)
            }).catch(error => reject(error.response.data))
          })
        },
        verifyTwoFACode(store, params) {
          return new Promise((resolve, reject) => {
            api.post('account/verify-two-fa-code', params).then(response => {
              if (response.data.error) {
                reject(response.data)
                return
              }

              resolve(response.data)
            }).catch(error => reject(error.response.data))
          })
        },
        serverKey(store) {
          return api.get('account/server-key').then(response => {
            store.commit('setServerKey', response.data.serverKey);
            return response.data.serverKey;
          })
        },
        verifyClientPin(store, params) {
          return api.post('account/verify-client-pin', params);
        },
        setClientPin(store, params) {
          return api.post('account/set-client-pin', params);
        },
        sendPinRecoveryMail(store,params) {
          return api.post('account/send-pin-recovery-mail');
        },
        verifyPinBatch(store,params) {
          return api.post('account/verify-pin-batch',params);
        },
        getPinHint() {
          return api.get('account/pin-hint').then(response => {
            return response.data.hint;
          });
        },
        changePanel(store, params) {
          return api.post('account/change-panel', params);
        }
    },
    mutations: {
        setProfile(state, data) {
            state.user = data;
        },
        setServerKey(state, data) {
            state.serverKey = data;
        },
    },
}



// WEBPACK FOOTER //
// ./src/store/modules/account.js